var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"content-header mt-2"},[_c('h3',[_vm._v("Connection: "+_vm._s(_vm.connection.name))]),_c('b-table',{attrs:{"stacked":"","items":[_vm.connection]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }